import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalDescription,
  ModalBody,
  ModalFooter,
} from '../../sectepe-ui/index';
import { mediaApi, groesseLesbar, KIND_LABELS, type MediaAsset } from '../../services/mediaService';
import { blobSpeichern } from '../../services/download';
import { MediaFassungen } from './MediaFassungen';

/**
 * Vorschau eines Mediums. <video>/<img>/<iframe> koennen keinen
 * Authorization-Header senden: der Inhalt kommt deshalb mit Bearer als Blob
 * und wird ueber eine Objekt-URL gezeigt, die beim Schliessen frei wird.
 * Darunter die Plattform-Fassungen (MediaFassungen).
 */
export const MediaPreview: React.FC<{ asset: MediaAsset; onClose: () => void; darfBearbeiten?: boolean }> = ({
  asset, onClose, darfBearbeiten = false,
}) => {
  const [url, setUrl] = useState<string | null>(null);
  const [fehler, setFehler] = useState('');
  const vorschaubar = asset.kind !== 'document';

  useEffect(() => {
    if (!vorschaubar) return undefined;
    let objektUrl: string | null = null;
    let abgebrochen = false;
    mediaApi.content(asset.id)
      .then((blob) => {
        if (abgebrochen) return;
        objektUrl = URL.createObjectURL(new Blob([blob], { type: asset.mimeType }));
        setUrl(objektUrl);
      })
      .catch(() => { if (!abgebrochen) setFehler('Die Vorschau konnte nicht geladen werden.'); });
    return () => {
      abgebrochen = true;
      if (objektUrl) URL.revokeObjectURL(objektUrl);
    };
  }, [asset.id, asset.mimeType, vorschaubar]);

  const speichern = async () => {
    try {
      blobSpeichern(await mediaApi.content(asset.id, true), asset.originalName);
    } catch {
      setFehler('Der Download ist fehlgeschlagen.');
    }
  };

  return (
    <Modal open onOpenChange={(offen) => { if (!offen) onClose(); }}>
      <ModalContent className="sec-modal--lg">
        <ModalHeader>
          <ModalTitle>{asset.title || asset.originalName}</ModalTitle>
          <ModalDescription>
            {KIND_LABELS[asset.kind]} · {groesseLesbar(asset.sizeBytes)} · {asset.originalName}
          </ModalDescription>
        </ModalHeader>
        <ModalBody>
          {fehler && <div className="alert alert-error">{fehler}</div>}
          {!vorschaubar && <p className="text-muted">Für Office-Dokumente gibt es keine Vorschau. Bitte herunterladen.</p>}
          {vorschaubar && !url && !fehler && <p className="text-muted">Vorschau wird geladen …</p>}
          {url && asset.kind === 'image' && (
            <img src={url} alt={asset.title || asset.originalName} style={{ maxWidth: '100%', maxHeight: '70vh' }} />
          )}
          {url && asset.kind === 'video' && (
            <video src={url} controls style={{ maxWidth: '100%', maxHeight: '70vh' }}>
              {/* Kampagnenclips haben (noch) keine Untertiteldatei */}
              <track kind="captions" />
            </video>
          )}
          {url && asset.kind === 'pdf' && (
            <iframe src={url} title={asset.title || asset.originalName} style={{ width: '100%', height: '70vh', border: 0 }} />
          )}
          {vorschaubar && <MediaFassungen asset={asset} darfBearbeiten={darfBearbeiten} />}
        </ModalBody>
        <ModalFooter>
          <button type="button" className="btn btn-secondary" onClick={onClose}>Schließen</button>
          <button type="button" className="btn btn-primary" onClick={speichern}>Herunterladen</button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default MediaPreview;
